import React from "react";
import PropTypes from "prop-types";
import { InputNumber } from "antd";

class NumberSelect extends React.Component {
    onChange = (type, val) => {
        const { value } = this.props;
        let newValue = value || [];
        newValue[type] = val;
        this.props.onChange(newValue);
    };
    render() {
        const { value, placeholder, ...restProps } = this.props;
        return (
            <div className={"d-flex"}>
                <InputNumber
                    type="text"
                    {...restProps}
                    placeholder={placeholder[0]}
                    value={value && value[0]}
                    className={"mr-5"}
                    onChange={this.onChange.bind(null, 0)}
                />
                <InputNumber
                    type="text"
                    {...restProps}
                    placeholder={placeholder[1]}
                    value={value && value[1]}
                    onChange={this.onChange.bind(null, 1)}
                />
            </div>
        );
    }
}

NumberSelect.propTypes = {
    value: PropTypes.object,
    addOnBefore: PropTypes.object,
    addOnAfter: PropTypes.object,
    placeholder: PropTypes.array,
    prefix: PropTypes.object,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    getValueFromObject: PropTypes.func
};

export default NumberSelect;
